module.exports = "h1 {\n    font-size: 2em;\n    padding-bottom: 15px;\n    text-align: center;\n    font-weight: 800;\n}\n\n.wrapper {\n    height: 100%;\n    position: fixed;\n    padding-top: 0px;\n    padding-bottom: 20px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.chart {\n    left: 0;\n    width: 60%;\n}\n\n.info {\n    right: 0;\n    width: 30%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tv/tv.component.css
// module id = ./src/app/tv/tv.component.css
// module chunks = main